export default __webpack_public_path__ + "static/media/VideoFXBanner.4003f4b0.svg";